export interface CreditCardEssentials {
  holderName: string;
  number: string;
  expiry: string;
  cvc: string;
}
